import { Box, Lottie } from '@betty/moonlight';
import { memo, useEffect } from 'react';
import { BottomSheetExtendedProps } from '@betty/navigation';
import useStatus from '../../hooks/useStatus';
import {
  StatusBoxesHeader,
  StatusBoxList,
  StatusInstructions,
  StatusResetDisclaimer,
  StatusTitleText,
} from '../../components';

function StatusBoxes({ close }: BottomSheetExtendedProps) {
  const { status, pendingRewardsCount } = useStatus();

  useEffect(() => {
    if (!pendingRewardsCount) {
      close();
    }
  }, [pendingRewardsCount, close]);

  useEffect(() => {
    Lottie.present({ animation: 'confetti' });
  }, []);

  if (!status || !status.pendingRewards.length) {
    return null;
  }

  return (
    <Box alignItems="center" gap="space-400">
      <StatusTitleText locKey="status_boxes_title" />
      <StatusBoxesHeader
        statusName={status.pendingRewards[0].sourceType}
        pendingRewardsCount={pendingRewardsCount}
      />
      <StatusBoxList status={status} />
      <StatusInstructions status={status} />
      <StatusResetDisclaimer status={status} />
    </Box>
  );
}

export default memo(StatusBoxes);
